module.exports = __webpack_public_path__ + "img/pd-img52.285f31e3.jpg";